import React from 'react';
import { Menu } from 'antd';
import { LineChartOutlined, BarChartOutlined, PieChartOutlined, HomeOutlined } from '@ant-design/icons';
import './MainNavigation.css';

const menuItems = [
  { key: 'home', label: '系统主页', icon: <HomeOutlined /> },
  { key: 'hydroForecast', label: '流域水文预报', icon: <LineChartOutlined /> },
  { key: 'cityWater', label: '城市用水预测', icon: <BarChartOutlined /> },
  { key: 'waterResource', label: '区域水资源配置', icon: <PieChartOutlined /> }
];

const MainNavigation = ({ currentPage, onChange }) => {
  return (
    <div className="main-navigation" style={{ borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}>
        <div style={{ fontWeight: 600, marginRight: 24 }}>智河管理系统</div>
        <Menu
          mode="horizontal"
          selectedKeys={[currentPage]}
          onClick={(e) => onChange && onChange(e.key)}
          style={{ flex: 1 }}
          items={menuItems.map(({ key, label, icon, disabled }) => ({ key, label, icon, disabled }))}
        />
      </div>
    </div>
  );
};

export default MainNavigation;